import { motion } from "framer-motion";
import { Heart } from "lucide-react";

const COLORS = ["#ff6b6b", "#2dd4bf", "#f5c451"];

// A brief burst of hearts that fans up and fades. Re-mounts on each new
// `trigger` value so it replays every time Max is petted (hovered).
export const HeartBurst = ({ trigger = 0, count = 5, iconSize = 18, className = "" }) => {
  if (!trigger) return null;
  return (
    <div
      key={trigger}
      className={`pointer-events-none absolute z-30 ${className}`}
      data-testid="heart-burst"
    >
      {Array.from({ length: count }).map((_, i) => {
        const spread = (i - (count - 1) / 2) * 16;
        return (
          <motion.span
            key={i}
            className="absolute left-0 top-0"
            initial={{ opacity: 0, x: 0, y: 0, scale: 0.4 }}
            animate={{
              opacity: [0, 1, 0],
              x: spread,
              y: -46 - (i % 3) * 12,
              scale: [0.4, 1, 0.85],
              rotate: i % 2 ? 12 : -12,
            }}
            transition={{ duration: 1.05, delay: i * 0.05, ease: "easeOut" }}
          >
            <Heart size={iconSize} fill={COLORS[i % COLORS.length]} color={COLORS[i % COLORS.length]} />
          </motion.span>
        );
      })}
    </div>
  );
};
